import React, { useRef } from "react";
import BusinessTabs from "./BusinessTabs";
import Section from "../../layouts/Section";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeatureHead from "./FeatureHead";

const Process = [
    {
        imgSrc: "/img/dt-process-img.png",
        imgSrcMb: "/img/dt-process-mb-img.png"
    }
];
const ProductLists = [
    {
        title: "Sales Cloud",
        description:
            "Sales Cloud로 잠재 고객 발굴부터 거래 성사까지 신속하고 혁신적인 영업을 시작할 수 있습니다.",
        imgSrc: "/img/salesforce/sales-day.svg"
    },
    {
        title: "Service Cloud",
        description:
            "세계 최고의 고객 서비스 소프트웨어를 통해 핵심적인 서비스를 경험해 보세요.",
        imgSrc: "/img/salesforce/service-day.svg"
    },
    {
        title: "Consumer Goods Cloud",
        description:
            "현장 담당자의 생산성을 높이고, 세일즈 관리자가 전 매장의 제품을 쉽게 관리할 수 있습니다.",
        imgSrc: "/img/salesforce/cgc-img.png"
    },
    {
        title: "Multi Cloud",
        description:
            "Multi Cloud는 서비스, 상거래 및 마케팅의 세 가지 클라우드 서비스를 결합하여 비즈니스를 발전시킵니다.",
        imgSrc: "/img/salesforce/multicloud.svg"
    },
    {
        title: "옴니채널 연동 Solution",
        description:
            "채널톡, 카카오 알림톡, 상담톡, 네이버 톡톡, Apple Message for Business, Facebook, LINE, WhatsApp 등과 연동이 가능합니다.",
        imgSrc: "/img/salesforce/omni-ch.png"
    },
    {
        title: "CTI Solution",
        description:
            "Salesforce용 CTI를 사용하면 전화 대화 및 통화를 데이터로 만들 수 있습니다.",
        imgSrc: "/img/salesforce/cti.png"
    },
    {
        title: "Tableau",
        description:
            "Sales Cloud로 잠재 고객 발굴부터 거래 성사까지 신속하고 혁신적인 영업을 시작할 수 있습니다.",
        imgSrc: "/img/salesforce/tableau-day.svg"
    },
    {
        title: "Heroku",
        description:
            "Sales Cloud로 잠재 고객 발굴부터 거래 성사까지 신속하고 혁신적인 영업을 시작할 수 있습니다.",
        imgSrc: "/img/salesforce/salesforce-heroku.png"
    },
    {
        title: "Data Cloud",
        description:
            "스마트 타겟팅, 빠른 세분화, 실시간 자동화로 시간과 비용을 절약하세요.",
        imgSrc: "/img/salesforce/mc-cdp-jt.png"
    },
    {
        title: "Industry Cloud",
        description:
            "세계 1위 CRM 플랫폼에 구축된 산업별 솔루션을 사용하여 어디에서나 디지털 전환을 가속화하고 성공하십시오.",
        imgSrc: "/img/salesforce/industries-day.svg"
    },
    {
        title: "Marketing Cloud",
        description:
            "데이터 중심의 디지털 마케팅으로 평생 고객 관계를 구축하세요.",
        imgSrc: "/img/salesforce/marketing-day.svg"
    },
    {
        title: "Loyalty Management",
        description:
            "개인화된 충성도 프로그램으로 고객을 적극적으로 참여시키고 고객이 다시 방문하도록 하십시오.",
        imgSrc: "/img/salesforce/loyalty-01.png"
    },
    {
        title: "Experience cloud",
        description:
            "Experience Cloud를 사용하여 여러 채널에서 고객과 상호 작용하십시오.",
        imgSrc: "/img/salesforce/experience-day.svg"
    },
    {
        title: "Customer Identity",
        description:
            "Salesforce 고객 ID에서 단일 로그인으로 사용자 액세스를 간소화합니다.",
        imgSrc: "/img/salesforce/identity.jpeg"
    },
];

const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
};

export const wrap = (min: number, max: number, v: number) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

const FeatureSalesforce = () => {
    const ref = useRef(null);
    const settings = {
        dots: true,
        autoplay: false,
        Speed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        arrows: false
    };

    return (
        <>
            <BusinessTabs current="dt" />

            <FeatureHead />
            {/* <div className="container mx-auto max-w-6xl space-y-52 p-6 px-8 py-12 lg:max-w-7xl lg:px-12"></div> */}

            <Section id="1" bg="gray" space="lg">
                    <p className="mx-auto mt-4 max-w-6xl font-bold text-brand text-h3">
                        Process
                    </p>
                    <h1 className="mt-2 mx-auto max-w-6xl font-bold tracking-tight text-gray-900 text-h1">
                        디지털 트렌스포메이션의 진행 방식을 소개합니다.
                    </h1>
                    <p className="m-auto mt-4 max-w-6xl font-normal text-gray-500 text-body">
                        데이터 통합을 통한 360 Views (매장360, 고객360, 제품360,
                        연령대360) 구현과 <br className="hidden sm:block" />
                        CRM Marketing, Tableau BI, Agentforce,
                        AI(Generative/Predictive) 기능 구축까지 제공합니다.
                    </p>
                    <div className="mt-8 max-w-6xl lg:-mx-12 lg:flex xl:m-auto xl:mt-16">
                        <div className="mt-8 flex-1 lg:mx-12 lg:mt-0">
                            <div className="mt-8 grid grid-cols-1 gap-8 xl:mt-12 xl:gap-12">
                                {Process.map(list => (
                                    <div key={list.imgSrc}>
                                        <img
                                            className="h-100 hidden w-full rounded-lg object-contain md:block"
                                            src={list.imgSrc}
                                            alt=""
                                        />
                                        <img
                                            className="h-100 m-auto block w-4/5 rounded-lg object-contain md:hidden"
                                            src={list.imgSrcMb}
                                            alt=""
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
            </Section>

            <Section width="6xl" space="lg">
                    <p className="mt-4 font-bold text-brand text-h3">
                        Products
                    </p>
                    <h1 className="mt-2 font-bold tracking-tight text-gray-900 text-h1">
                        디지털 트렌스포메이션 제품을 소개합니다.
                    </h1>
                    <div className="mt-8 lg:-mx-12 lg:flex xl:mt-16">
                        <div className="lg:mx-12">
                            <div className="mt-4 space-y-4 lg:mt-8">
                                <a className="block text-gray-500 hover:underline dark:text-gray-300">
                                    전체 상품
                                </a>
                            </div>
                        </div>
                        <div className="mt-8 flex-1 lg:mx-12 lg:mt-0">
                            <div className="mt-8 grid grid-cols-1 gap-[50px] sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 xl:mt-12 xl:gap-12">
                                {ProductLists.map(list => (
                                    <div key={list.title}>
                                        <img
                                            className="h-36 w-full rounded-lg object-contain "
                                            src={list.imgSrc}
                                            alt=""
                                        />
                                        <h2 className="mt-4 text-h3 font-semibold capitalize text-gray-800 dark:text-white">
                                            {list.title}
                                        </h2>
                                        <p className="mt-2 text-body text-gray-500">
                                            {list.description}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
            </Section>
        </>
    );
};

export default FeatureSalesforce;
